import Vue from 'vue'
import VueRouter from 'vue-router'
import Top from '@/pages/Top.vue'
import SignIn from '@/pages/SignIn.vue'
import Registered from '@/pages/Registered.vue'
import SignOut from '@/pages/SignOut.vue'
/* import Privacy from '@/pages/Privacy.vue' */
import Terms from '@/pages/Terms.vue'
import HowToUse from '@/pages/HowToUse.vue'
import CourseSyllabus from '@/pages/CourseSyllabus.vue'
import CourseList from '@/pages/CourseList.vue'
/* import AllCourseList from '@/pages/AllCourseList.vue' */
import UnitList from '@/pages/UnitList.vue'
import UnitTest from '@/pages/UnitTest.vue'
import Lesson from '@/pages/Lesson.vue'
import LessonList from '@/pages/LessonList.vue'
import Certification from '@/pages/Certification.vue'
import Survey from '@/pages/Survey.vue'
import CallBack from '@/pages/CallBack.vue'
import repository from '@/store/repository'
/* import KatexTest from '@/pages/KatexTest.vue' */
/* import KatexTest2 from '@/pages/KatexTest2.vue' */

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '',
    component: Top,
    children: [
      {
        path: '',
        name: 'CourseList',
        component: CourseList
      },
      {
        path: 'cb',
        name: 'Call-Back',
        component: CallBack
      },
      /* {
        path: 'all-course-list',
        name: 'All-Course-List',
        component: AllCourseList
      }, */
      /* {
        path: 'katex',
        name: 'KatexTest',
        component: KatexTest
      },* /
      /* {
        path: 'katex2',
        name: 'KatexTest2',
        component: KatexTest2
      }, */
      {
        path: 'sign-in',
        name: 'SignIn',
        component: SignIn
      },
      {
        path: 'registered',
        name: 'Registered',
        component: Registered,
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'sign-out',
        name: 'SignOut',
        component: SignOut,
        meta: { requiresAuth: true }
      },
      {
        path: '/:courseId/survey/:which',
        name: 'Survey',
        component: Survey,
        meta: { requiresAuth: true }
      },
      /* {
        path: 'privacy',
        name: 'Privacy',
        component: Privacy
      }, */
      {
        path: 'terms',
        name: 'Terms',
        component: Terms
      },
      {
        path: '/howtouse',
        name: 'HowToUse',
        component: HowToUse
      },
      {
        path: '/:courseId',
        name: 'CourseSyllabus',
        component: CourseSyllabus
      },
      {
        path: '/:courseId/unit-list',
        name: 'UnitList',
        component: UnitList,
        meta: { requiresAuth: true }
      },
      {
        path: '/:courseId/certification',
        name: 'Certification',
        component: Certification,
        meta: { requiresAuth: true }
      },
      {
        path: '/:courseId/:unitId/unit-test',
        name: 'UnitTest',
        component: UnitTest,
        meta: { requiresAuth: true }
      },
      {
        path: '/:courseId/:unitId/lesson-list',
        name: 'LessonList',
        component: LessonList,
        meta: { requiresAuth: true }
      },
      {
        path: '/:courseId/:unitId/lesson',
        name: 'Lesson',
        component: Lesson,
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (repository.isSignedIn()) {
      next()
    } else {
      next({ name: 'SignIn', query: { redirect: to.path } })
    }
  } else {
    next()
  }
})

export default router
